import { getFontSize, getLineHeight } from '../../typography/typography.alias';
import { getColor, getBackgroundColor, getBorderColor, getOutlineColor, } from '../../colors/colors.alias';
import { getBorderStyle, getBorderWidth, getOutlineOffset, getOutlineStyle, getOutlineWidth, } from '../../borders/borders.alias';
import { getHeight } from '../../sizes/sizes.alias';
import { constants as Icon } from '../Icon';
import { VARIANT_DEFAULT, ELEMENT_BUTTON, ELEMENT_ICON, INTERACTION_STATE_ACTIVE, INTERACTION_STATE_HOVER, INTERACTION_STATE_FOCUS_VISIBLE, } from '../../constants';
import { getBoxShadow } from '../../shadows/shadows.alias';
export const constants = Object.freeze({
    NAME: 'AddButton',
    variants: {
        VARIANT_DEFAULT,
    },
    elements: {
        ELEMENT_BUTTON,
        ELEMENT_ICON,
    },
    interactionStates: {
        INTERACTION_STATE_ACTIVE,
        INTERACTION_STATE_HOVER,
        INTERACTION_STATE_FOCUS_VISIBLE,
    },
});
export default function getAddButton(transformer, config) {
    const borderStyle = getBorderStyle(transformer, config);
    const borderColor = getBorderColor(transformer, config);
    const borderWidth = getBorderWidth(transformer, config);
    const backgroundColor = getBackgroundColor(transformer, config);
    const color = getColor(transformer, config);
    const fontSize = getFontSize(transformer);
    const lineHeight = getLineHeight(transformer);
    const height = getHeight(transformer);
    const outlineOffset = getOutlineOffset(transformer, config);
    const outlineWidth = getOutlineWidth(transformer, config);
    const outlineColor = getOutlineColor(transformer, config);
    const outlineStyle = getOutlineStyle(transformer, config);
    const boxShadow = getBoxShadow(transformer, config);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_BUTTON]: {
                styles: {
                    borderStyle: borderStyle.button.add.default.value,
                    borderColor: borderColor.button.add.default.value,
                    borderWidth: borderWidth.button.add.value,
                    backgroundColor: backgroundColor.button.add.default.value,
                    color: color.button.add.text.value,
                    fontSize: fontSize.button.m.value,
                    lineHeight: lineHeight.body.get(fontSize.button.m.value),
                    height: height.button.m.value,
                },
                interactionStates: {
                    [INTERACTION_STATE_ACTIVE]: {
                        styles: {
                            borderColor: borderColor.button.add.interactionStates[INTERACTION_STATE_ACTIVE].value,
                            backgroundColor: backgroundColor.button.add.interactionStates[INTERACTION_STATE_ACTIVE].value,
                            boxShadow: boxShadow.button.add.interactionStates[INTERACTION_STATE_ACTIVE]
                                .value,
                        },
                    },
                    [INTERACTION_STATE_HOVER]: {
                        styles: {
                            borderColor: borderColor.button.add.interactionStates[INTERACTION_STATE_HOVER].value,
                            backgroundColor: backgroundColor.button.add.interactionStates[INTERACTION_STATE_HOVER].value,
                            boxShadow: boxShadow.button.add.interactionStates[INTERACTION_STATE_HOVER]
                                .value,
                        },
                    },
                    [INTERACTION_STATE_FOCUS_VISIBLE]: {
                        styles: {
                            outlineOffset: outlineOffset.default.value,
                            outlineStyle: outlineStyle.default.value,
                            outlineWidth: outlineWidth.default.value,
                            outlineColor: outlineColor.default.interactionStates[INTERACTION_STATE_FOCUS_VISIBLE].value,
                        },
                    },
                },
            },
            [ELEMENT_ICON]: {
                styles: {
                    color: color.button.add.icon.value,
                },
                components: {
                    [Icon.NAME]: {
                        variant: Icon.variants.VARIANT_MEDIUM,
                    },
                },
            },
        },
    });
}
